import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { time_ago } from "@utils/metrics/timeFunction";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import styles from "../styles/blog.module.css";
import Image from "next/legacy/image";
const BlogItem = ({
  data,
  index,
  allBlogsPage = false
}) => {
  const router = useRouter();
  const {
    t
  } = useTranslation();
  return <div className={styles.blogCardWrapper} onClick={e => {
    e.preventDefault();
    router.push(`/blogs/${data?.urlExtension}`);
  }} data-sentry-component="BlogItem" data-sentry-source-file="blogItem.jsx">
      {data?.images && data.images.length > 0 && <Image src={data?.images[0] ?? ""} alt={t("temple-image")} className={styles.blogCardImg} width={500} height={250} placeholder="blur" blurDataURL={data?.images[0] ?? ""} loading="eager" priority />}

      {/* {allBlogsPage && data?.images && data.images.length > 0 && (
        <Image
          src={data?.images[0] ?? ""}
          alt={t("temple-image")}
          className={styles.blogCardImg}
          width={240}
          height={120}
          placeholder="blur"
          blurDataURL={data?.images[0] ?? ""}
          loading="eager"
          priority
        />
       )} */}

      <div className={styles.blogCardDetail}>
        <div className={styles.blogCardHead}>{data?.headline}</div>

        <div className={styles.cardBottom}>
          {data?.User?.dp ? <div className={styles.blogAuthorImg}>
              <Image src={data?.User?.dp} alt={t("blog-author-image")} className={styles.ratingImg} height={45} width={45} layout="responsive" objectFit="cover" placeholder="blur" blurDataURL={data?.User?.dp} loading="eager" priority />
            </div> : <AccountCircleIcon className={styles.blogAuthorImg} />}

          <div className={styles.teamName}>
            <div>
            {data?.User?.name}{" "} 
            </div>
            <div>{time_ago(data?.newTs)}</div>
          </div>

        </div>

      </div>

    </div>;
};
export default BlogItem;